const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
const DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export { MONTHS, DAYS };

export function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function sameDay(a, b) {
  if (!a || !b) return false;
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function isBefore(a, b) {
  return startOfDay(a) < startOfDay(b);
}

export function nightsBetween(a, b) {
  if (!a || !b) return 0;
  return Math.round((startOfDay(b) - startOfDay(a)) / 86400000);
}

export function formatShortDate(date) {
  if (!date) return '';
  return `${WEEKDAYS[date.getDay()]} ${date.getDate()} ${MONTHS_SHORT[date.getMonth()]}`;
}

export function formatLongDate(date) {
  if (!date) return '';
  return `${WEEKDAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function monthMatrix(year, month) {
  const first = new Date(year, month, 1);
  const startPad = first.getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startPad; i += 1) cells.push(null);
  for (let d = 1; d <= daysInMonth; d += 1) cells.push(new Date(year, month, d));
  while (cells.length % 7 !== 0) cells.push(null);
  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));
  return weeks;
}

export function occupancyLabel(occupancy) {
  const adultWord = occupancy.adults === 1 ? 'adult' : 'adults';
  return `${occupancy.adults} ${adultWord}`;
}

export function nightsLabel(nights) {
  return `${nights} ${nights === 1 ? 'night' : 'nights'}`;
}

export function formatPrice(gbp) {
  return `TSh ${Math.round(gbp * 3400)}`;
}

function hashId(id) {
  let h = 0;
  for (let i = 0; i < id.length; i += 1) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h;
}

export function bookedRangesFor(id, today = startOfDay(new Date())) {
  const h = hashId(id);
  const bucket = h % 3;
  if (bucket === 0) return [];
  if (bucket === 1) {
    return [{ start: addDays(today, 1), end: addDays(today, 8) }];
  }
  return [{ start: addDays(today, 14), end: addDays(today, 21) }];
}

function staysOverlap(aStart, aEnd, bStart, bEnd) {
  return startOfDay(aStart) < startOfDay(bEnd) && startOfDay(aEnd) > startOfDay(bStart);
}

export function isStayAvailable(property, checkIn, checkOut, today) {
  if (!checkIn || !checkOut) return true;
  return !bookedRangesFor(property.id, today).some((range) => (
    staysOverlap(checkIn, checkOut, range.start, range.end)
  ));
}
